<app-header></app-header>
 <div class="wrapper">
    <div class="bg-grey"  >
      <div class="container-fluid ">
        <router-outlet />
       
      </div>
    </div>
  </div>
<app-footer></app-footer>